import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["canvas"]
  static values = { endpoint: String }

  connect() {
    this.fetchAndDraw()
    this._onTheme = () => this.draw()
    document.addEventListener("theme-changed", this._onTheme)
  }

  disconnect() {
    document.removeEventListener("theme-changed", this._onTheme)
  }

  async fetchAndDraw() {
    try {
      const resp = await fetch(this.endpointValue)
      if (!resp.ok) return
      this.data_ = await resp.json()
      this.draw()
    } catch (e) {
      // silent fail
    }
  }

  draw() {
    if (!this.data_ || !this.data_.length) return

    const canvas = this.canvasTarget
    const ctx = canvas.getContext("2d")
    const dpr = window.devicePixelRatio || 1
    const rect = canvas.getBoundingClientRect()

    canvas.width = rect.width * dpr
    canvas.height = rect.height * dpr
    ctx.scale(dpr, dpr)

    const w = rect.width
    const h = rect.height
    const prices = this.data_.map(d => d.close)
    const min = Math.min(...prices)
    const max = Math.max(...prices)
    const range = max - min || 1

    const trending = prices[prices.length - 1] >= prices[0]
    const isDark = document.documentElement.getAttribute("data-theme") === "dark"

    const lineColor = trending ? "#22C55E" : "#EF4444"
    const fillColor = trending
      ? (isDark ? "rgba(34, 197, 94, 0.08)" : "rgba(34, 197, 94, 0.06)")
      : (isDark ? "rgba(239, 68, 68, 0.08)" : "rgba(239, 68, 68, 0.06)")

    ctx.clearRect(0, 0, w, h)

    // Draw fill
    ctx.beginPath()
    prices.forEach((p, i) => {
      const x = (i / (prices.length - 1)) * w
      const y = h - ((p - min) / range) * (h * 0.85) - h * 0.05
      if (i === 0) ctx.moveTo(x, y)
      else ctx.lineTo(x, y)
    })
    ctx.lineTo(w, h)
    ctx.lineTo(0, h)
    ctx.closePath()
    ctx.fillStyle = fillColor
    ctx.fill()

    // Draw line
    ctx.beginPath()
    prices.forEach((p, i) => {
      const x = (i / (prices.length - 1)) * w
      const y = h - ((p - min) / range) * (h * 0.85) - h * 0.05
      if (i === 0) ctx.moveTo(x, y)
      else ctx.lineTo(x, y)
    })
    ctx.strokeStyle = lineColor
    ctx.lineWidth = 2
    ctx.stroke()

    // Price label
    const lastPrice = prices[prices.length - 1]
    ctx.fillStyle = isDark ? "#A0A0A0" : "#666666"
    ctx.font = "600 11px Inter, system-ui, sans-serif"
    ctx.textAlign = "right"
    ctx.fillText(`$${lastPrice.toLocaleString("en-US", { maximumFractionDigits: 0 })}`, w - 8, 16)
  }
}
